<template>
    <div></div>
</template>

<script>
    export default {

        components: {
        },

        data() {
            return {};
        },

        methods: {
        },

        beforeCreate() {
            this.$router.push("/user/about/list");
        },

        created() {
        },

        beforeMount() {
        },

        mounted() {
        },

        beforeUpdate() {
        },

        updated() {
        },

        beforeDestroy() {
        },

        destroyed() {
        },

    };
</script>
